// Shared design tokens for branded PDF exports. Keep these in sync with
// the in-app brand palette in `tokens.css` so a downloaded report looks
// like a finished document - not a screenshot of a spreadsheet.

export type RGB = [number, number, number]

// Palette mirrors the in-app reporting tables: muted greys for the
// section/total bars, subtle brand blue only for accents (header stripe,
// totals top-border, money text). Avoid heavy fills - downloaded reports
// should feel like an accountant's document, not a marketing brochure.
export const PDF_COLORS = {
  brandPrimary: [0, 114, 206] as RGB,    // accent only - stripes, money text
  brandAccent:  [124, 58, 237] as RGB,
  ink:          [15, 23, 42]  as RGB,    // headline text
  body:         [30, 41, 59]  as RGB,    // body text
  muted:        [100, 116, 139] as RGB,  // metadata + footer text
  hairline:     [226, 232, 240] as RGB,  // table borders / dividers
  panel:        [248, 250, 252] as RGB,  // zebra stripe background
  panelStrong:  [241, 245, 249] as RGB,  // sub-section background
  panelHeader:  [228, 232, 240] as RGB,  // top-level section bar (Assets)
  panelTotal:   [219, 225, 235] as RGB,  // grand-totals band (slightly darker)
  success:      [21, 128, 61] as RGB,
  successPanel: [220, 252, 231] as RGB,
  danger:       [185, 28, 28] as RGB,
  dangerPanel:  [254, 226, 226] as RGB,
  white:        [255, 255, 255] as RGB,
}

export const PDF_FONT = {
  // Page chrome
  reportTitle: 22,
  companyName: 13,
  // Sections + totals: hold the body weight (9pt) so an all-caps label
  // like NET INCOME doesn't visually balloon next to mixed-case rows.
  sectionHeader: 9.5,
  subSection: 8.5,
  totalLabel: 9,
  metaLabel: 8,
  metaValue: 9,
  body: 9,
  footer: 8,
}

export const PDF_LAYOUT = {
  margin: 14,           // left/right page margin (mm)
  topMargin: 14,
  bottomMargin: 18,     // leaves room for footer
  headerHeight: 30,     // brand bar height
  rowHeight: 6.5,       // default body row height
  sectionBarHeight: 9,
  totalsBarHeight: 8,
  indent: 4,            // per-level indent for hierarchical lines
  thinLine: 0.2,
  mediumLine: 0.4,
  thickLine: 0.8,
}
